// extracted by mini-css-extract-plugin
export default {"videoCallButtonEnabled":"MessageInput_videoCallButtonEnabled__cUVqD","videoCallButtonDisabled":"MessageInput_videoCallButtonDisabled__llV+r"};